import type { Feedback } from '@@partner:types:app'

import React, { useState } from 'react'
import Zoombox from 'zoombox'
import { Tag } from 'rsuite'

import './CustomerFeedback.scss'

export interface CustomerFeedbackProps {
  feedback: Feedback
}

export default function CustomerFeedback ({ feedback }: CustomerFeedbackProps) {
  const [ state, setState ] = useState({
    isVisible: false,
    slide: 0
  })

  const handleShowImage = (slide: number) => {
    setState({
      isVisible: true,
      slide
    })
  }

  const images = (feedback?.images ?? []).filter((image) => !!image.url)

  if (!feedback) {
    return <></>
  }

  return (
    <div className="CustomerFeedback">
      <div className="flex items-start">
        <div className="max-w-5xl w-1/2">
          <div className="my-2 flex flex-col">
            <strong>Текст отзыва:</strong>
            <span
              style={{ wordBreak: 'break-all' }}
            >{`${feedback.review}`}</span>
          </div>
        </div>
        <div className="ml-2 w-1/2">
          <div className="my-2">
            <strong>Общая оценка: </strong>
            <span>{feedback.general_rating || 0}</span>
          </div>

          {!!feedback.need_call && (
            <Tag color="red" size="md">
              Требуется звонок
            </Tag>
          )}
        </div>
      </div>
      { images && images.length > 0 && (
        <div className="w-full">
          <strong>Фото</strong>
          <div className="CustomerFeedback__Gallery ">
            {images.map((image, index) => (
              <img
                onClick={() => handleShowImage(index)}
                src={image.url}
                className="CustomerFeedback__Gallery__Items"
                key={`FeedbackGallery_${feedback.id}_${index}`}
              />
            ))}

            <Zoombox
              active={state.isVisible}
              maskClosable
              lockBodyScroll
              enableImageDragBeta
              images={images.map((image) => ({
                src: image.url as string,
                caption: ''
              }))}
              selectedImage={state.slide}
              setActive={(active) => {
                setState((state) => ({ ...state, isVisible: !!active }))
              }}
            />
          </div>
        </div>
      )}
    </div>
  )
}
